<template>
  <div class="">
    <Flow v-bind:step="2"/>
    <div class="cart_wrap bg_white mt12">
      <p class="cart_title ab c5a">新しく選択した定期購入リスト合計</p>
      <div class="price_wrap">
        <p class="price_sum rm" v-model="this.bcTotalPrice"><span class="yen ab">￥</span>{{ this.bcTotalPrice.toLocaleString() }}</p>
        <p class="cart_point rm" v-model="this.bcTotalPoint"><span class="point ab">ポイント：</span>{{ this.bcTotalPoint.toLocaleString() }}<span class="cart_pt ab">pt</span></p>
      </div>
    </div>
    <div class="item_wrap bg_white pt16">
      <h2 class="content_title"> 新しく選択した定期購入リスト</h2>
      <div class="pl16 pr16 mt24">
        <h3 class="nowBC rb c5a bdb">BC：<span class="bc_number rb">{{ this.nowBC }}</span></h3>
      </div>
      <div v-if="this.cartItems.length != 0">
        <div class="select_item bdb" v-for="(value, n) in cartItems" :key="n">
          <div class="image_wrap">
            <div class="select_image">
              <img :src="imagePath + value.product.imagePath" :alt="value.product.productName" v-on:error="imageError" :data-noimage="imagePath + value.product.noImagePath">

            </div>
            <p class="select_item--title ab" v-html="value.product.productName">{{ value.product.productName }}</p>
            <button v-if="value.product.genre.genreId != 3 && !value.goodDeal" class="delete btn_delete btn_mini" v-on:click="updateCart(n, 'delete')">削除</button>
          </div>
          <div class="select_contents">
            <div class="manth_wrap">
              <div class="month_item">
                <p class="month ab c5a">定期購入</p>
                <div class="count_wrap">
                  <span class="count ab c5a">数量</span>
                  <div v-if="value.product.genre.genreId != 3 && !value.goodDeal" class="bottom_arrow select_count">
                    <select name="buy_count" id="" class="c5a rb" v-on:change="updateCart(n, value.orderCount)" v-model="value.orderCount">
                      <option v-for="n of 10" :value="n" :key="n">{{ n }}</option>
                    </select>
                  </div>
                  <div v-else class="select_count">
                    <p class="c5a rb">{{ value.orderCount }}</p>
                  </div>
                </div>
              </div>
              <p v-if="value.goodDeal" class="good_deal_description ab c5a">{{ value.goodDealDescription }}</p>
            </div>
            <div v-if="value.product.genre.genreId != 3 && !value.goodDeal" class="kodomo_wrap">
              <input class="kodomo_check" type="checkbox" v-bind:id="'kodomo' + n" name="checkbox01" v-on:change="updateCart(n, value.childFund)" v-model="value.childFund" v-bind:checked="value.childFund">
              <label v-bind:for="'kodomo' + n" class="checkbox01 ab c5a">こども基金を支援する</label>
            </div>
            <div class="select_price">
              <p class="item_price rm c5a"><span class="yen ab">￥</span>{{ value.childFund ? ((value.product.price * value.orderCount) + (100 * value.orderCount)).toLocaleString() : (value.product.price * value.orderCount).toLocaleString() }}</p>
              <p class="item_point rm c5a"><span class="point_text ab">ポイント：</span>{{ (value.product.point * value.orderCount).toLocaleString() }}<span class="point ab">pt</span></p>
            </div>
          </div>
        </div>
      </div>

      <div class="cart_none" v-else>
        <p class="rb c5a">現在、定期購入されている商品はありません。</p>
      </div>
    </div>

    <div class="service_wrap bg_white pt16 pb48 mt12">
      <div v-if="hasGoodDeal" class="good_deal_notice">
        <p class="rb c5a">※お得定期便ご利用中は設定を変更できません。<br>変更をご希望される際は、コールセンターまでご連絡ください。</p>
      </div>
      <router-link class="btn_blue" :to="{ name: 'repeatSelectPaymentAndShipping' }">確定</router-link>
      <router-link class="btn_delete" :to="{ name: 'subSelectProducts' }">戻る</router-link>
    </div>
  </div>
</template>

<script>
import Flow from '@/components/subscription/Flow'
import Config from '@/config/config'
import CheckOrder from '@/model/checkSelectRepeatOrder';

export default {
  components: {
    Flow,
  },
  data () {
    return {
      imagePath: Config.APIURL,
      nowBC: localStorage.getItem('subNowBC'),
      cart: true,
      cartItems: [],
      bcTotalPrice: 0,
      bcTotalPoint: 0,
      change: true,
    };
  },
  computed: {
    hasGoodDeal() {
      return this.cartItems.some(item => item.goodDeal === true);
    }
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    createData () {
      this.bcTotalPrice = 0;
      this.bcTotalPoint = 0;
      this.cartItems.splice(0, this.cartItems.length);
      let items = JSON.parse(localStorage.getItem('repeatItemList'));
      if(items) {
        for (var i = 0; i < items.length; i++) {
          for (var a = 0; a < items[i].itemList.length; a++) {
            items[i].itemList[a].repeatOrder ? this.cartItems.push(items[i].itemList[a]) : '';
          }
        }
      }
      if(this.cartItems.length != 0) {
        for (var i = 0; i < this.cartItems.length; i++) {
          let totalPrice = this.cartItems[i].product.price * this.cartItems[i].orderCount;
          let totalPoint = this.cartItems[i].product.point * this.cartItems[i].orderCount;
          this.bcTotalPrice = this.bcTotalPrice + totalPrice;
          this.bcTotalPoint = this.bcTotalPoint + totalPoint;
          if (this.cartItems[i].childFund) {
            this.bcTotalPrice = this.bcTotalPrice + (100 * this.cartItems[i].orderCount);
          }
        }
      }
    },
    updateCart (n, data) {
      let repeatItemList = JSON.parse(localStorage.getItem('repeatItemList'));
      if(repeatItemList) {
        for (var i = 0; i < repeatItemList.length; i++) {
          for (var a = 0; a < repeatItemList[i].itemList.length; a++) {
            if(repeatItemList[i].itemList[a].product.productId == this.cartItems[n].product.productId) {
              if(Number.isInteger(data)) {
                // 購入数の変更
                repeatItemList[i].itemList[a].orderCount = data;
              } else if(data == 'delete') {
                // 削除
                repeatItemList[i].itemList[a].repeatOrder = false;
                repeatItemList[i].itemList[a].orderCount = 1;
                repeatItemList[i].itemList[a].childFund = false;
              } else {
                // 子供基金の変更
                repeatItemList[i].itemList[a].childFund ? repeatItemList[i].itemList[a].childFund = false : repeatItemList[i].itemList[a].childFund = true;
              }
            }
          }
        }
      }
      localStorage.setItem('repeatItemList', JSON.stringify(repeatItemList));
      this.createData();
      let result = CheckOrder.checkSelectRepeatOrder();
      this.setSubscriptioncheckSelectRepeatOrder(result);
    },
    setSubscriptioncheckSelectRepeatOrder(result) {
      this.$store.commit('setSubscriptioncheckSelectRepeatOrder', result);
    },
  },
  created () {
    this.createData();
  },
};
</script>

<style lang="css" scoped>

.content_title {
  width: 241px;
}

.nowBC {
  font-size: 20px;
  line-height: 1;
  padding-bottom: 7px;
}
/* カートに商品がない場合 */
.cart_none {
  font-size: 14px;
  padding: 69px 0;
  text-align: center;
}
/* カート中身 */
.detail_wrap {
  padding-top: 74px;
}

.cart_wrap {
  border-bottom: 1px solid #c9c9c9;
  padding: 24px 16px 10px;
}

.cart_title {
  border-left: 4px solid  #4FCCD4;
  font-size: 18px;
  padding-left: 4px;
}

.price_wrap {
  color: #009FA9;
  margin-top: 25px;
  text-align: right;
}

.price_sum {
  font-size: 28px;
}

.yen {
  font-size: 22px;
}

.cart_point {
  font-size: 18px;
}

.point {
  font-size: 14px;
}

.cart_pt {
  font-size: 14px;
}

.cart_tab input {
  display: none;
}

.cart_tab {
  border-bottom: 1px solid  #aaa;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.cart_tab .tab {
  border: solid #AAAAAA;
  border-width: 1px 1px 0;
  border-radius: 12px 12px 0 0;
  background-color: #f4f4f4;
  color: #A3A3A3;
  font-size: 20px;
  padding: 9px 0 8px 16px;
  width: 49.9%;
}

.cart_tab .tab.isActive {
  background-color: #fff;
  color: #5a5a5a;
}

.other_bc {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 37px 16px 25px;
}
.bc_number {
  font-size: 20px;
}

.other_number--detail {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}
.other_bc--price {
  font-size: 26px;
}
.yen {
  font-size: 20px;
}
.btn_mini {
  margin: 16px 0 0;
}

.select_item {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 25px 15px 24px 24px;
}
.image_wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  width: 33%;
}

.select_image {
  /* margin: auto;
  width: 73%; */
}

.month_item {
  align-items: flex-end;
  display: flex;
}

.count_wrap {
  align-items: flex-end;
  display: flex;
  margin-left: 20px;
  width: 56%;
}

.select_item--title {
  font-size: 12px;
  margin-top: 5px;
}
.btn_delete {
  margin: 21px auto 0;
}

.select_contents {
  margin-top: 10px;
  width: 59%;
}

.manth_wrap {
  margin-top: 0;
}

.month {
  font-size: 16px;
  line-height: 1;
}

.month_number {
  font-size: 22px;
}

.count {
  font-size: 14px;
  line-height: 1;
}

.select_count {
  border-bottom: 1px solid #5a5a5a;
  margin-left: 8px;
  /* width: 70%; */
  width: 63%;
}
.select_count:after {
  bottom: 6px;
  right: 0;
}
.select_count select,
.select_count p {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 26px;
  padding-left: 23px;
  width: 100%;
}



.checkbox01 {
  display: flex;
  font-size: 14px;
  justify-content: flex-end;
  margin-top: 35px;
  padding: 5px 0 5px 30px;
}

.checkbox01::before {
  left: 0;
}

.checkbox01::after {
  left: 5px;
}

.select_price {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
}

.item_price {
  font-size: 26px;
}

.yen {
  font-size: 20px;
}

.item_point {
  font-size: 16px;
}

.point_text {
  font-size: 12px;
}

.select_sum {
  display: block;
  margin-top: 0;
  padding: 24px 15px;
}

.select_sum .item_price {
  margin-top: 0;
}

.select_sum .subtotal {
  font-size: 14px;
}

.btn_blue {
  margin-top: 32px;
}

.good_deal_notice {
  font-size: 14px;
  padding: 0 16px;
}

.good_deal_description {
  font-size: 14px;
  margin: 8px 0 0;
  white-space: break-spaces;
}
</style>



// WEBPACK FOOTER //
// src/views/subscription/SubSelectProductsList.vue